module.exports = __webpack_public_path__ + "img/kangminjianlogo.e7b6633a.png";